import { useAppStore } from '@/stores/appStore'
import * as Sentry from '@sentry/vue'
import { sentryDsns } from '@team-milva/lab-constants/sentry'
import { getEnvironmentLabel } from './host'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export function initSentry({
  router,
  app,
}: {
  router: Router
  app: App<Element>
}) {
  const { appVersion } = useAppStore()
  Sentry.init({
    app,
    dsn: sentryDsns['lab-management'],
    environment: getEnvironmentLabel(),

    release: `management@${appVersion}`,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
      Sentry.browserTracingIntegration({ router }),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  })
}

